import { useTheme } from '../context/ThemeContext'

function KPITable({ kpis, isWellLevel = false }) {
    const { theme } = useTheme()
    const isDark = theme === 'dark'

    if (!kpis) return null

    const rows = [
        { label: 'Gross Oil Production', unit: 'BBL', color: 'bg-green-500', key: 'oil' },
        { label: 'Gross Gas Production', unit: 'MCF', color: 'bg-red-500', key: 'gas' },
        { label: 'Gross Water Production', unit: 'BBL', color: 'bg-blue-500', key: 'water' }
    ]

    const periods = ['today', 'l7d', 'l30d']
    const periodLabels = { today: 'Today', l7d: 'L7D Avg', l30d: 'L30D Avg' }

    const formatVar = (v) => {
        if (v === null || v === undefined) return '--'
        const sign = v > 0 ? '+' : ''
        return `${sign}${v.toFixed(1)}%`
    }

    const varClass = (v) => {
        if (v === null || v === undefined) return isDark ? 'text-gray-500' : 'text-gray-400'
        if (v > 0) return isDark ? 'text-green-400' : 'text-green-600'
        if (v < 0) return isDark ? 'text-red-400' : 'text-red-600'
        return isDark ? 'text-gray-400' : 'text-gray-500'
    }

    return (
        <div className="space-y-3">
            {rows.map(row => {
                const data = periods.map(p => kpis[p]?.[row.key] || {})
                return (
                    <div key={row.key}>
                        {/* Section header */}
                        <div className={`flex items-center gap-2 mb-1.5`}>
                            <span className={`inline-block w-full h-6 ${row.color} rounded text-white text-xs font-bold flex items-center justify-center`}>
                                {row.label}
                            </span>
                        </div>

                        {/* Data grid */}
                        <div className="grid grid-cols-4 gap-x-2 text-xs">
                            {/* Row labels */}
                            <div></div>
                            {periods.map(p => (
                                <div key={p} className={`text-center font-bold pb-1 ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                    {periodLabels[p]}
                                </div>
                            ))}

                            {/* Actual row */}
                            <div className={`font-semibold ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>Actual</div>
                            {data.map((d, i) => (
                                <div key={i} className={`text-center font-mono font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
                                    {d.actual?.toLocaleString() || '0'}
                                </div>
                            ))}

                            {/* Forecast row */}
                            <div className={`font-semibold ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>Forecast</div>
                            {data.map((d, i) => (
                                <div key={i} className={`text-center font-mono ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                    {d.forecast ? d.forecast.toLocaleString() : '--'}
                                </div>
                            ))}

                            {/* Variance row */}
                            <div className={`font-semibold ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>% Variance</div>
                            {data.map((d, i) => (
                                <div key={i} className={`text-center font-mono font-semibold ${varClass(d.variance)}`}>
                                    {formatVar(d.variance)}
                                </div>
                            ))}
                        </div>
                    </div>
                )
            })}

            {isWellLevel && (
                <p className={`text-[10px] italic ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
                    Forecast shown at combo level
                </p>
            )}
        </div>
    )
}

export default KPITable
